import styled from 'styled-components';

import { Space } from 'antd';
import { SummaryCardStyles } from 'components/common/SummaryCardCustom/styles';
import CardSectionStyles from 'components/common/CardSection/styles';

export const ParentProfileStyles = styled.div`
  ${CardSectionStyles} {
    padding: 0;
    .title-card {
      padding: 12px 24px;
    }
    .ant-table-container table > thead > tr:first-child th:first-child {
      border-top-left-radius: 0;
    }
    .ant-table-container table > thead > tr:first-child th:last-child {
      border-top-right-radius: 0;
    }
    .ant-divider-horizontal {
      margin: 0 !important;
    }
    .ant-table-pagination.ant-pagination {
      margin: 16px;
    }
  }

  ${SummaryCardStyles} {
    box-shadow: 0px 3px 8px -1px #3232470d;
    border: 1px solid #ecedf1;
  }
`;

export const ParentAndChildrenInfoStyles = styled.div`
  .ant-avatar {
    background: ${({ theme }) => theme.background.neutral100};
  }
`;

export const EnquiriesSummaryCardSpace = styled(Space)`
  --gap: 20px;
  --columns: 1;
  --width: calc(
    (100% / var(--columns)) - var(--gap) + (var(--gap) / var(--columns))
  );

  .ant-space-item {
    flex-grow: 1;
    flex-basis: var(--width);
    max-width: var(--width);
  }
  .wrapper-icon {
    font-size: 48px;
  }

  @media only screen and (min-width: 992px) {
    --columns: 2;
  }
  @media only screen and (min-width: 1200px) {
    --columns: 3;
  }
  @media only screen and (min-width: 1600px) {
    --columns: 5;
  }
`;

export const ActionsStyles = styled.div`
  .ant-btn .anticon {
    color: ${({ theme }) => theme.text.gray700};
    font-size: 16px;
  }
  .action-feature-icon {
    font-size: 16px;
    right: 15px;
    top: -2px;
  }
`;

export const EnquiryTypeStyles = styled.div`
  .anticon svg {
    font-size: 16px;
  }
`;

export const ChildCardStyles = styled.div`
  .ant-avatar {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
